import axios from 'axios';
import authHeader from "@/service/auth-header";

class ClientLabelService {

    async getClientLabels(clientId) {
        return await axios.get(`/api/clientlabel/${clientId}`, {headers: authHeader()})
    }

    async getClientsForLabel(labelId) {
        return await axios.get(`/api/clientlabel/label/${labelId}`, {headers: authHeader()})
    }

    async createLabelForClient(clientId, labelId) {
        return await axios.post(`/api/clientlabel/${clientId}/${labelId}`, null, {headers: authHeader()});
    }

    async updateSpecificLabelForClient(id, data) {
        return await axios.put(`/api/clientlabel/${id}`, data, {headers: authHeader()});
    }

    async deleteSpecificLabelForClient(id) {
        return await axios.delete(`/api/clientlabel/${id}`, {headers: authHeader()})
    }

}

export default new ClientLabelService();
